function populateDays() {
  const daySelect = document.getElementById('day');
  daySelect.innerHTML = '<option value="">- Day -</option>';

  for (let i = 1; i <= 31; i++) {
    const option = document.createElement('option');
    option.value = i;
    option.text = i;
    daySelect.add(option);
  }
}

function populateMonths() {
  const monthSelect = document.getElementById('month');
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  monthSelect.innerHTML = '<option value="">- Month -</option>';

  months.forEach((month, index) => {
    const option = document.createElement('option');
    option.value = index + 1;
    option.text = month;
    monthSelect.add(option);
  });
}

function populateYears() {
  const yearSelect = document.getElementById('year');
  const currentYear = new Date().getFullYear();

  yearSelect.innerHTML = '<option value="">- Year -</option>';

  for (let i = currentYear; i >= currentYear - 100; i--) {
    const option = document.createElement('option');
    option.value = i;
    option.text = i;
    yearSelect.add(option);
  }
}

function validateAge() {
  const day = parseInt(document.getElementById('day').value);
  const month = parseInt(document.getElementById('month').value);
  const year = parseInt(document.getElementById('year').value);

  if (!day || !month || !year) {
    alert('Please select a valid date of birth.');
    return;
  }

  const dob = new Date(year, month - 1, day);
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  if (age >= 18) {
    localStorage.setItem('ageVerified', 'true');
    document.getElementById('agePopup').style.display = 'none';
  } else {
    window.location.href = 'https://www.google.com/';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const isVerified = localStorage.getItem('ageVerified');

  if (isVerified === 'true') {
    document.getElementById('agePopup').style.display = 'none';
    return;
  }

  populateDays();
  populateMonths();
  populateYears();
});
